import React from 'react';

const Logo = ({ ...props }: React.ComponentProps<"svg">) => {
    return <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1915 887" style={{ overflow: 'visible' }} {...props}>
        <title>Comunidad PAS</title>
        <g>
            <path fill="currentColor" d="M1377.7,755.8l49.9-83.6c9.4-16.7,29.4-16.7,39.9-8.3c5.9,3.6,95.8,70.4,172.2,70.4
    c61.1,0,106.9-40.5,106.9-91.8c0-60.8-50.5-102.5-149.2-143c-110.4-45.3-220.8-116.8-220.8-257.5c0-106.1,77.5-228.9,264.3-228.9
    c119.8,0,211.4,62,234.9,79.9c11.7,7.2,15.3,27.4,7.1,39.3l-44.6,67.9c-9.4,14.3-27,23.8-41.1,14.3c-9.4-6-98.3-70.3-162.9-70
    c-78.6,0.3-109.6,51-109.6,89.1c0,56,49.4,92.9,144.5,132.3c114,46.5,245.5,115.6,245.5,269.4c0,122.8-104.5,250.3-270.2,250.3
    c-148,0-237.4-71.4-260.9-94C1373,780.9,1367.2,774.9,1377.7,755.8z"/>
            <path fill="currentColor" d="M298.4,25h-276C9.4,25,0,35.8,0,47.7v815.3c0,11.9,9.4,22.7,22.3,22.7h108.1
    c11.7,0,22.3-10.7,22.3-22.7V599.4v-42.7V411.2v-19V168.5H289c65.8,0,130.3,47.8,130.3,119.6c0,81.3-64.4,119.4-130.2,119.4h-11.4
    c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0-0.9,0h-0.4l0,0c-10.5,0.7-18.8,9.5-18.8,20.3v105.5h0c0.4,10.8,9.5,17.5,20.3,17.5l22.9,0
    c143.3,0,261.5-114.7,261.5-262.5C561.5,144.2,442.8,25,298.4,25z"/>
            <path fill="currentColor" d="M1318,855.8L943.8,26.2c-3.5-7.1-8.2-13.1-20-13.1h-11.7c-10.6,0-16.4,6-20,13.1L514.9,855.8
    c-7.1,15.5,2.3,31,20,31h102.2c18.8,0,29.4-11.9,34.1-23.8l57.8-130l0,0l82.8-189.3l0.1,0l101.6-231.4h3.5l117.5,262.2l-105.1-0.1
    c-8.1,0-15,4.9-18.2,11.9l0,0L868.4,678l0,0c-0.8,1.5-1.2,3.2-1.2,5.1c0,6.2,5,11.3,11.1,11.3l208.9,0.4l74.6,168.2
    c8.2,16.7,16.4,23.8,34.1,23.8H1298C1315.7,886.8,1325.1,871.3,1318,855.8z"/>
        </g>
    </svg >
}

export default Logo;